import { useTranslation } from "react-i18next";
import { CRadio } from ".";
import { CRadioGroupProps } from "./radio-group";
import React from "react";

export const CRadioPriority: React.FC<CRadioGroupProps> = ({ ...props }) => {
  const { t } = useTranslation();
  const options = [
    { label: t("very-important"), value: "very" },
    { label: t("medium-important"), value: "medium" },
    { label: t("less-important"), value: "less" },
  ];
  return <CRadio.Group {...props} options={options} />;
};
